module.exports = "/_next/static/images/6ca01fa52466a7925ca5d51c7a21476f-2-cards@0.5x.jpg";